import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=0b9fe92e&"
import script from "./Body.vue?vue&type=script&lang=ts&"
export * from "./Body.vue?vue&type=script&lang=ts&"
import style0 from "./Body.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports